import React from 'react';
import { HeroSection } from './HeroSection';
import { OpeningHook } from './OpeningHook';
import { FailedSolutions } from './FailedSolutions';
import { MechanismSection } from './MechanismSection';
import { WhatYouGet } from './WhatYouGet';
import { WhoIsFor } from './WhoIsFor';
import { HowItWorks } from './HowItWorks';
import { ProofSection } from './ProofSection';
import { FAQSection } from './FAQSection';
import { OfferSection } from './OfferSection';
import { Footer } from './Footer';
export function SalesPage() {
  return <div className="min-h-screen bg-[#0a0f1a] text-slate-300 font-sans selection:bg-cyan-500/30 selection:text-cyan-100" data-id="element-159">
      <HeroSection data-id="element-160" />
      <OpeningHook data-id="element-161" />
      <FailedSolutions data-id="element-162" />
      <MechanismSection data-id="element-163" />
      <WhatYouGet data-id="element-164" />
      <WhoIsFor data-id="element-165" />
      <HowItWorks data-id="element-166" />
      <ProofSection data-id="element-167" />
      <FAQSection data-id="element-168" />
      <OfferSection data-id="element-169" />
      <Footer data-id="element-170" />
    </div>;
}